import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import CrossSpinner from './components/homeSpinner/CrossSpinner';
import SERVER_API_URL from './config';

export default function App() {
  const [isAppLoading, setIsAppLoading] = useState(true);

  useEffect(() => {
    const getAggregateData = async () => {
      try {
        const response = await axios.get(`${SERVER_API_URL}/landing/getAggregateData`);
        if (response.status === 200) {
          setIsAppLoading(false);
        }
      } catch (e) {
        // console.log(e);
      }
    };
    getAggregateData();
    // setTimeout(() => {
    //   setIsAppLoading(false);
    // }, 7000);
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          {isAppLoading ? (
            <CrossSpinner />
          ) : (
            <>
              <ScrollToTop />
              <StyledChart />
              <Router />
            </>
          )}
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
